import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import apiUrl from "../../utils/ApiConfig";
import AlertA from "../../utils/AlertA";
import alertC from "../../utils/AlertC";

export default function LoginB() {
  const navigat = useNavigate();
  const {
    control,
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
    },
  });
  /////////////////////////////////
  const alertX = () =>
    AlertA(
      "center",
      "success",
      "ثبت نام با موفقیت انجام شد...",
      1500,
      "#9933cc",
      "#9933cc"
    );
  const alertY = (text) =>
    AlertA("center", "error", text, 1500, "#9933cc", "#9933cc");
  //////////////////////////////////
  const alerZ = () =>
    alertC(
      "ثبت نام با موفقیت انجام شد",
      "برای تایید حساب کاربری خود به ایدی ... پیام دهید.",
      "success",
      "متوجه شدم",
      "#9933cc",
      "#9933cc"
    );
  const handleRegistration = (data) => {
    let obj = {
      un: data.phone,
      pw: data.password,
      name: data.name,
    };
    async function myApp() {
      const res = await fetch(`${apiUrl}/api/User/register`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
      }).then((res) => {
        if (res.ok) {
          return res.json().then((result) => {
            alerZ();
            // alertX();
            navigat("/");
          });
        } else {
          return res.json().then((result) => {
            alertY(result.msg);
            // alert();
          });
        }
      });
    }
    if (data.password === data.repeatpassword) {
      myApp();
    } else if (data.password !== data.repeatpassword) {
      alertY("رمز عبور یکسان نمیباشد...");
    }
  };

  return (
    <>
      {/* <button
        onClick={() => {
          alerZ();
        }}
      ></button> */}
      <Form onSubmit={handleSubmit(handleRegistration)}>
        <Form.Group className="mb-3" controlId="formLastName">
          <Form.Label>نام خانوادگی:</Form.Label>
          <Form.Control
            type="text"
            placeholder="نام خانوادگی خود را وارد کنید . ."
            {...register("name", { required: "نام الزامی است" })}
            isInvalid={!!errors.name}
          />
          <Form.Control.Feedback type="invalid">
            {errors.name?.message}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formPhone">
          <Form.Label>شماره همراه:</Form.Label>
          <Form.Control
            type="number"
            placeholder="شماره همراه خود را وارد کنید . ."
            {...register("phone", {
              required: " شماره همراه الزامی است",
              minLength: 11,
              maxLength: 11,
            })}
            isInvalid={!!errors.phone}
          />
          <Form.Control.Feedback type="invalid">
            {errors.phone?.message}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formPassword">
          <Form.Label>رمز عبور:</Form.Label>
          <Form.Control
            type="password"
            placeholder="یک رمز عبور وارد کنید . ."
            {...register("password", {
              required: "رمز عبور الزامی است (حداقل 4کاراکتر) ",
              minLength: 4,
            })}
            isInvalid={!!errors.password}
          />
          <Form.Control.Feedback type="invalid">
            {errors.password?.message}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formPassword">
          <Form.Label>تکرار رمز عبور:</Form.Label>
          <Form.Control
            type="password"
            placeholder=" رمز عبور را مجدد وارد کنید . ."
            {...register("repeatpassword", {
              required: " تکرار رمز عبور الزامی است (حداقل 4کاراکتر) ",
              minLength: 4,
            })}
            isInvalid={!!errors.repeatpassword}
          />
          <Form.Control.Feedback type="invalid">
            {errors.repeatpassword?.message}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formCheckbox">
          <Controller
            name="terms"
            control={control}
            rules={{ required: "تایید قوانین الزامی است" }}
            render={({ field }) => (
              <Form.Check
                {...field}
                type="checkbox"
                label="توضیحات را خواندم و می‌پذیرم."
                isInvalid={!!errors.terms}
              />
            )}
          />
          <Form.Control.Feedback type="invalid">
            {errors.terms?.message}
          </Form.Control.Feedback>
        </Form.Group>

        <Button type="submit" variant="primary">
          ثبت نام
        </Button>
      </Form>
    </>
  );
}
